import { FileCustom } from "../interfaces"
import ButtonBig from "../../../../shared/components/button_big"


export const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

export const FileRow = ({ file, onRemove }: { file: FileCustom, onRemove: any }) => {


    const getItem = (type: string) => {
        if (type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
            return <img src='/assets/icons/excel_icon.svg' width={30} height={30} alt='' />
        } else if (type === 'application/pdf') {
            return <img src='/assets/icons/pdf.svg' width={30} height={30} alt='' />
        } else if (type === 'image/png') {
            return <img src='/assets/icons/image_icon.svg' width={30} height={30} alt='' />
        } else {
            return <img src='/assets/icons/other_file.svg' width={30} height={30} alt='' />
        }

    }

    return (
        <div className='Upload_files_container_member_list_container_item_file' >
            <div>{getItem(file.fileType)} </div>
            < div > {file.fileName} </div>
            < div > {file.fileSize} </div>
            < div > {file.status} </div>
            < ButtonBig text='Remover' onClick={() => onRemove(file)} />
        </div>
    )
}